// Sidebars partagées pour les pages Réseau Desktop (Galerie, Salon, Événements, Cinéma)
// Réplique exacte des sidebars de ActuPage.jsx pour cohérence visuelle

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// ═══ DONNÉES PARTAGÉES ═══
const FEED_TABS = [
  { id: 'tout', label: 'Tout' },
  { id: 'acote', label: 'À côté' },
  { id: 'suivis', label: 'Suivis' },
  { id: 'promos', label: 'Promos' },
];

const METIERS_LIST = [
  { value: 'tous', label: 'Tous les métiers', color: '#1E3A5F' },
  { value: 'pisciniste', label: 'Pisciniste', color: '#06B6D4' },
  { value: 'plombier', label: 'Plombier', color: '#3B82F6' },
  { value: 'electricien', label: 'Électricien', color: '#EAB308' },
  { value: 'macon', label: 'Maçon', color: '#EA580C' },
  { value: 'carreleur', label: 'Carreleur', color: '#10B981' },
  { value: 'peintre', label: 'Peintre', color: '#EC4899' },
  { value: 'menuisier', label: 'Menuisier', color: '#92400E' },
  { value: 'couvreur', label: 'Couvreur', color: '#7C3AED' },
  { value: 'chauffagiste', label: 'Chauffagiste', color: '#EF4444' },
  { value: 'paysagiste', label: 'Paysagiste', color: '#22C55E' },
  { value: 'climaticien', label: 'Climaticien', color: '#0891B2' },
];

// Navigation secondaire supprimée - déjà présente dans le sous-menu horizontal

// Les événements et pros actifs seront chargés depuis le backend en production

// ═══ SIDEBAR GAUCHE ═══
export function LeftSidebar({ currentPage }) {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('tout');
  const [selectedMetier, setSelectedMetier] = useState(null);

  return (
    <div style={{
      width: '280px',
      flexShrink: 0,
    }}>
      <div style={{
        position: 'sticky',
        top: '160px',
        maxHeight: 'calc(100vh - 180px)',
        overflowY: 'auto',
      }}>
        <div style={{
          background: '#fff',
          borderRadius: '16px',
          padding: '16px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        }}>
          <h3 style={{
            fontSize: '14px',
            fontWeight: 700,
            color: '#1a2a4a',
            marginBottom: '16px',
            paddingLeft: '8px',
          }}>
            Explorer le Réseau
          </h3>
          
          {/* Onglets principaux */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '6px',
            marginBottom: '16px',
          }}>
            {FEED_TABS.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setSelectedTab(tab.id)}
                style={{
                  padding: '10px 12px',
                  background: selectedTab === tab.id ? '#FFF3EC' : '#F5F5F7',
                  border: selectedTab === tab.id ? '1px solid #FDDCCC' : '1px solid transparent',
                  borderRadius: '10px',
                  color: selectedTab === tab.id ? '#E8650A' : '#374151',
                  fontSize: '13px',
                  fontWeight: selectedTab === tab.id ? 600 : 500,
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
          
          {/* Filtre par métier */}
          <div style={{ marginBottom: '16px' }}>
            <label style={{
              display: 'block',
              fontSize: '11px',
              fontWeight: 600,
              color: '#6B7280',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              marginBottom: '8px',
              paddingLeft: '4px',
            }}>
              Filtrer par métier
            </label>
            <div style={{ position: 'relative' }}>
              <select
                value={selectedMetier || 'tous'}
                onChange={(e) => setSelectedMetier(e.target.value === 'tous' ? null : e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 40px 12px 16px',
                  background: '#FFFFFF',
                  border: '2px solid #E5E7EB',
                  borderRadius: '12px',
                  color: '#1E3A5F',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  appearance: 'none',
                  transition: 'all 0.2s',
                  outline: 'none',
                }}
              >
                {METIERS_LIST.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </select>
              <div style={{
                position: 'absolute',
                right: '14px',
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
                color: '#6B7280',
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </div>
            
            {selectedMetier && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginTop: '10px',
                padding: '8px 12px',
                background: '#F8FAFC',
                borderRadius: '8px',
                border: '1px solid #E2E8F0',
              }}>
                <div style={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  background: METIERS_LIST.find(m => m.value === selectedMetier)?.color || '#1E3A5F',
                }} />
                <span style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#374151',
                  flex: 1,
                }}>
                  {METIERS_LIST.find(m => m.value === selectedMetier)?.label}
                </span>
                <button
                  onClick={() => setSelectedMetier(null)}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    padding: '2px',
                    cursor: 'pointer',
                    color: '#9CA3AF',
                    display: 'flex',
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            )}
          </div>
          
          {/* Séparateur supprimé - navigation secondaire supprimée */}
        </div>
      </div>
    </div>
  );
}

// ═══ SIDEBAR DROITE ═══
export function RightSidebar() {
  const navigate = useNavigate();

  return (
    <div style={{ width: '320px', flexShrink: 0 }}>
      <div style={{ 
        position: 'sticky', 
        top: '160px',
        maxHeight: 'calc(100vh - 180px)',
        overflowY: 'auto',
      }}>
        {/* Événements à venir - État vide production */}
        <div style={{
          background: '#fff',
          borderRadius: '16px',
          padding: '16px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        }}>
          <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#1a2a4a', marginBottom: '16px' }}>
            🎪 Événements à venir
          </h3>
          <div style={{
            textAlign: 'center',
            padding: '20px 0',
            color: '#9CA3AF',
            fontSize: '13px',
          }}>
            Aucun événement pour le moment
          </div>
          <button 
            onClick={() => navigate('/reseau/evenements')}
            style={{
              width: '100%',
              padding: '10px',
              marginTop: '8px',
              background: '#FFF3EC',
              border: '1px solid #E8650A',
              borderRadius: '8px',
              color: '#E8650A',
              fontSize: '13px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Voir tous les événements
          </button>
        </div>
        
        {/* Pros actifs - État vide production */}
        <div style={{
          background: '#fff',
          borderRadius: '16px',
          padding: '16px',
          marginTop: '16px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        }}>
          <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#1a2a4a', marginBottom: '16px' }}>
            👷 Pros actifs
          </h3>
          <div style={{
            textAlign: 'center',
            padding: '20px 0',
            color: '#9CA3AF',
            fontSize: '13px',
          }}>
            Aucun pro actif pour le moment
          </div>
        </div>
      </div>
    </div>
  );
}
